module.exports = __webpack_public_path__ + "media/images/icons/products-36cc9c83da968bf4c14a0cacb3c42ee5.gif";